export default __webpack_public_path__ + "static/media/Discord.cf175fca.svg";